import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFilter2"><Path d="M2 4H22V6H2V4Z" fill="currentColor"/><Path d="M8 18H16V20H8V18Z" fill="currentColor"/><Path d="M5 11V13H19V11H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilter2;
